import moment from 'moment';
import {EventBus} from '@/event-bus.js';

const dateRegExp = /[0-9][0-9]\.[0-9][0-9]\.[0-9][0-9][0-9][0-9]/;
const timeRegExp = /[0-9][0-9]:[0-9][0-9]/;

export default {
    changePopupWindowVisibility(val) {
        EventBus.$emit('window-visibility-change', {
            visible: !!val
        });
    },

    distinctArray(arr) {
        return arr.filter((elem, pos, arr) => arr.indexOf(elem) == pos)
    },

    formatLongitude(lp) {
        let pz = this.prependZeroToSingleDigitNumber;
        return `${pz(lp.degrees)}°${pz(lp.minutes)}′${pz(lp.seconds)}″${!!lp.retrograde ? ' R' : ''}`;
    },

    formatCurrency(amount) {
        return Number.parseFloat(amount)
                .toFixed(2).toString()
    },

    inclineNumeral(num, endingArray) {
        let remainder = Number(num) % 100;
        let ending;

        if (remainder >= 11 && remainder <= 19) {
            ending = endingArray[2];
        } else {
            remainder = remainder % 10;
            switch (remainder) {
                case 1:
                    ending = endingArray[0];
                    break;
                case 2:
                case 3:
                case 4:
                    ending = endingArray[1];
                    break;
                default:
                    ending = endingArray[2];
            }
        }

        return ending;
    },

    // 5 => "05"
    prependZeroToSingleDigitNumber(num) {
        return ("0" + num).slice(-2);
    },

    validateDateString(dateString) {
        if (!dateString)
            return false;
        return dateRegExp.test(dateString);
    },

    validateTimeString(timeString) {
        if (!timeString)
            return false;
        return timeRegExp.test(timeString);
    },

    validateNatalInputData(date, time, city) {
        return this.validateNatalInputDateTime(date, time)
                && this.validateNatalInputCity(city);
    },

    validateNatalInputDateTime(date, time) {
        return !!date && !!time
                && this.validateDateString(date)
                && this.validateTimeString(time);
    },

    validateNatalInputCity(city) {
        return !!city
                && city.lat != null
                && city.lng != null;
    },

    /**
     * Декартово произведение массивов
     */
    cartesianProductOf() {
        return Array.prototype.reduce.call(arguments, function (a, b) {
            var ret = [];
            a.forEach(function (a) {
                b.forEach(function (b) {
                    ret.push(a.concat([b]));
                });
            });
            return ret;
        }, [[]]);
    },

    concatDateAndTime(date, time) {
        return '' + date + ' ' + time + ':00';
    },

    createDateAsUTC(date) {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
    },

    convertDateToUTC(date) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    },

    getUnixTimeOfBirthdateAndTime(birthday, birthtime) {
        let result;
        if (birthday) {
            let hours;
            let minutes;
            if (birthtime && birthtime.length > 0) {
                hours = Number(birthtime.split(':')[0]);
                minutes = Number(birthtime.split(':')[1]);
            } else {
                hours = 12;
                minutes = 0;
            }

            result = moment(this.createDateAsUTC(new Date(moment(birthday, "DD.MM.YYYY")
                    .set({hour: hours, minute: minutes, second: 0, millisecond: 0})
                    .valueOf()))).valueOf();
        } else {
            result = null;
        }

        return result;
    }

}